import React from 'react';
import { ATMGrid, ATMHeader } from 'shared-it-appmod-ui';
import FieldReadOnly from 'src/components/atoms/field/field-readonly/field-readonly.component';
import Lang from 'src/libraries/language';

type IProps = {
  data:any;
};

const FlightRequestContactInformation: React.FC<IProps> = ({ data }) => {
  return (
    <>
      <ATMHeader size="small" className="text-underline">
        {Lang.TTL_CONTACT_INFORMATION}
      </ATMHeader>

      <ATMGrid columns={3}>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_FLIGHT_OPERATOR}>
            {data.operatorName}
          </FieldReadOnly>
        </ATMGrid.Column>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_PILOT_IN_COMMAND}>
            {data.pilotName}
          </FieldReadOnly>
        </ATMGrid.Column>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_PILOT_NUMBER}>
            {data.pilotPhone}
          </FieldReadOnly>
        </ATMGrid.Column>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_PRIME_CONTRACTOR}>
            {data.primeContractor}
          </FieldReadOnly>
        </ATMGrid.Column>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_CONTACT_NAME}>
            {data.primeName}
          </FieldReadOnly>
        </ATMGrid.Column>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_CONTRACTOR_NUMBER}>
            {data.primePhone}
          </FieldReadOnly>
        </ATMGrid.Column>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_CONTRACTOR_EMAIL}>
            {data.primeEmail}
          </FieldReadOnly>
        </ATMGrid.Column>
      </ATMGrid>
    </>
  );
};

export default FlightRequestContactInformation;
